import { clickEvent } from 'utils/adaConfigurations/customEvents';
import { VEHICLE_ADA } from 'constants/vehicleADA';

const {
  FORWARD,
  BACKWARD,
  ADA_CLASS,
  CARD_BODY,
  HEADER_ARROW_BACK
} = VEHICLE_ADA;

const VEHICLE_PAGE_ADA_ELEMENTS = [
  {
    cssName: 'icon icon-chevron__left slick-arrow slick-prev',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'icon icon-chevron__right slick-arrow slick-next',
    eventName: 'keyup',
    eventFn: clickEvent
  },
  {
    cssName: 'make card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'year card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'model card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'transmission card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'drive type card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'trim card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'engine type card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'engine size card-body',
    eventName: null,
    eventFn: null
  },
  {
    cssName: 'mileage card-body',
    eventName: null,
    eventFn: null
  }
];

export const getTabElements = (vehicleEditableEnabled: boolean) => {
  const selector = '.slick-slide';
  let htmlTag;
  let subItems;
  let i;
  let tabIndex;
  let isCardBody;
  let isArrowDisabled;
  let ancestorElement;

  VEHICLE_PAGE_ADA_ELEMENTS.forEach(elementCss => {
    tabIndex = 0;
    htmlTag = document.getElementsByClassName(elementCss.cssName)[0];
    if (htmlTag) {
      isCardBody =
        elementCss.cssName.indexOf(CARD_BODY) !== -1 &&
        elementCss.cssName.indexOf(`mileage ${CARD_BODY}`) === -1;
      isArrowDisabled = htmlTag.className.indexOf('disabled') !== -1;
      if (isArrowDisabled) {
        tabIndex = -1;
      }
      if (isCardBody) {
        subItems = htmlTag.getElementsByClassName(ADA_CLASS);
        ancestorElement = htmlTag;

        // For IE
        const matches = htmlTag.matches ? 'matches' : 'msMatchesSelector';
        while (ancestorElement) {
          if (ancestorElement[matches](selector)) {
            break;
          }
          ancestorElement = ancestorElement.parentElement;
        }
        if (
          !ancestorElement ||
          !ancestorElement.classList.contains('slick-active') ||
          !vehicleEditableEnabled
        ) {
          tabIndex = -1;
        }
        for (i = 0; i < subItems.length; i++) {
          subItems[i].setAttribute('tabindex', tabIndex);
          subItems[i].setAttribute('aria-disabled', tabIndex === -1);
        }
      }
      htmlTag.setAttribute('tabindex', tabIndex);
      htmlTag.setAttribute('aria-disabled', tabIndex === -1);
      if (elementCss.eventName && elementCss.eventFn) {
        htmlTag.addEventListener(
          elementCss.eventName,
          elementCss.eventFn.bind(htmlTag),
          false
        );
      }
    }
  });
};

const findFirstCard = () => {
  const cardElement = document.getElementsByClassName(CARD_BODY);
  let i;
  for (i = 0; i < cardElement.length; i++) {
    if (cardElement[i].tabIndex === 0) {
      return cardElement[i].className;
    }
  }
};

export const goNextTabElement = (direction, event, isEditable) => {
  const cssName = event.target.className;
  const arrowPrevElement = document.getElementsByClassName(
    'slick-arrow slick-prev'
  )[0];
  const arrowNextElement = document.getElementsByClassName(
    'slick-arrow slick-next'
  )[0];
  let htmlTag;

  if (isEditable) {
    switch (direction) {
      case BACKWARD:
        if (cssName.indexOf(CARD_BODY) !== -1) {
          if (cssName === findFirstCard()) {
            if (
              arrowNextElement &&
              arrowNextElement.className.indexOf('disabled') !== -1
            ) {
              htmlTag = arrowPrevElement;
            } else {
              htmlTag = arrowNextElement;
            }
            htmlTag && event.preventDefault();
          } else {
            arrowNextElement && arrowNextElement.setAttribute('tabindex', -1);
          }
        }
        if (cssName.indexOf('slick-next') !== -1) {
          if (
            arrowPrevElement &&
            arrowPrevElement.className.indexOf('disabled') !== -1
          ) {
            htmlTag = document.getElementsByClassName(HEADER_ARROW_BACK)[0];
          } else {
            htmlTag = arrowPrevElement;
          }
          htmlTag && event.preventDefault();
        }
        break;
      case FORWARD:
        if (cssName.indexOf('slick-prev') !== -1) {
          if (
            arrowNextElement &&
            arrowNextElement.className.indexOf('disabled') !== -1
          ) {
            htmlTag = document.getElementsByClassName(findFirstCard())[0];
          } else {
            htmlTag = arrowNextElement;
          }
          htmlTag && event.preventDefault();
        }
        if (cssName.indexOf('slick-next') !== -1) {
          event.preventDefault();
          htmlTag = document.getElementsByClassName(findFirstCard())[0];
        }
        if (
          cssName.indexOf(ADA_CLASS) !== -1 ||
          cssName.indexOf(CARD_BODY) !== -1
        ) {
          arrowNextElement && arrowNextElement.setAttribute('tabindex', -1);
        }
        if (cssName.indexOf(HEADER_ARROW_BACK) !== -1) {
          if (
            arrowPrevElement &&
            arrowPrevElement.className.indexOf('disabled') !== -1
          ) {
            htmlTag = document.getElementsByClassName(
              'slick-arrow slick-next'
            )[0];
            htmlTag && event.preventDefault();
          }
        }
        break;
      default:
        break;
    }
  }
  htmlTag && htmlTag.focus();
};

export const getCardFocus = (isEditable, showMileage) => {
  const cardElement = document.getElementsByClassName(CARD_BODY);
  const cardElementsLength = cardElement.length;
  let i;
  getTabElements(isEditable);

  if (cardElementsLength - Number(showMileage) > 3) {
    for (i = 0; i < cardElementsLength; i++) {
      if (cardElement[i].tabIndex === 0) {
        if (!cardElement[i].contains(document.activeElement)) {
          cardElement[i].focus();
        }
        break;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/adaConfigurations/VehicleBuilderADA.js